(() => {
  if (!customElements.get('voltara-cart-drawer')) {
    customElements.define('voltara-cart-drawer', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.dialog = this.querySelector('dialog');
        if (!this.dialog?.showModal) return;
        const signal = this.abort.signal;
        document.addEventListener('click', event => {
          const link = event.target.closest('.vt-bag-link');
          if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
          event.preventDefault(); this.open();
        }, { signal });
        this.querySelectorAll('[data-drawer-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), { signal }));
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const r = this.dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
        }, { signal });
        this.dialog.addEventListener('close', () => { this.request?.abort(); document.documentElement.classList.remove('vt-drawer-open'); }, { signal });
      }
      async changeQuantity(item, direction) {
        if (this.changing) return;
        this.changing = true;
        const status = this.querySelector('[data-drawer-status]');
        status.textContent = this.dataset.updating;
        this.querySelectorAll('.vt-drawer-stepper button').forEach(button => { button.disabled = true; });
        this.dialog.setAttribute('aria-busy', 'true');
        const step = item.quantity_rule?.increment || 1;
        const minimum = item.quantity_rule?.min || 1;
        const quantity = direction < 0 && item.quantity - step < minimum ? 0 : item.quantity + direction * step;
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ id: item.key, quantity }) });
          const cart = await response.json();
          if (!response.ok) throw new Error(typeof cart.description === 'string' ? cart.description : this.dataset.updateError);
          document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = String(cart.item_count); });
          if (this.dialog.open) {
            await this.open(cart);
            const target = [...this.querySelectorAll('.vt-drawer-stepper button')].find(button => button.dataset.key === item.key && Number(button.dataset.direction) === direction);
            this.querySelectorAll('.vt-drawer-stepper button').forEach(button => { button.disabled = false; });
            (target || this.querySelector('[data-drawer-close]'))?.focus({ preventScroll: true });
          }
        } catch (error) { status.textContent = error.message || this.dataset.updateError; }
        finally {
          this.changing = false;
          this.dialog.removeAttribute('aria-busy');
          this.querySelectorAll('.vt-drawer-stepper button').forEach(button => { button.disabled = false; });
        }
      }
      async open(snapshot) {
        if (!this.dialog?.showModal) return;
        this.request?.abort(); this.request = new AbortController();
        const signal = this.request.signal;
        const status = this.querySelector('[data-drawer-status]');
        const items = this.querySelector('[data-drawer-items]');
        const total = this.querySelector('.vt-drawer-total');
        const tax = this.querySelector('.vt-drawer-tax');
        const review = this.querySelector('[data-drawer-review]');
        const shop = this.querySelector('[data-drawer-shop]');
        items.replaceChildren(); status.textContent = this.dataset.loading;
        this.querySelector('[data-drawer-count]').textContent = '';
        total.hidden = true; tax.hidden = true; review.hidden = false; shop.hidden = true;
        if (!this.dialog.open) this.dialog.showModal();
        document.documentElement.classList.add('vt-drawer-open');
        items.setAttribute('aria-busy', 'true');
        try {
          const root = window.Shopify?.routes?.root || '/';
          let cart = snapshot;
          if (!cart) {
            const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store', signal });
            if (!response.ok) throw new Error('Cart unavailable');
            cart = await response.json();
          }
          if (signal.aborted) return;
          const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cart.currency, currencyDisplay: 'code' }).format(value / 100);
          const make = (tag, className, value) => { const el = document.createElement(tag); el.className = className; if (value !== undefined) el.textContent = value; return el; };
          const safeLink = value => { const url = new URL(value, window.location.origin); return url.origin === window.location.origin ? url.href : root + 'collections/all'; };
          cart.items.forEach(item => {
            const row = make('article', 'vt-drawer-item');
            const imageLink = make('a', 'vt-drawer-image'); imageLink.href = safeLink(item.url); imageLink.setAttribute('aria-label', item.product_title);
            if (item.featured_image?.url || item.image) { const image = make('img', ''); image.src = item.featured_image?.url || item.image; image.alt = ''; image.loading = 'lazy'; imageLink.append(image); }
            const info = make('div', 'vt-drawer-item-info');
            const title = make('a', 'vt-drawer-item-title', item.product_title); title.href = safeLink(item.url); info.append(title);
            if (item.variant_title && item.variant_title !== 'Default Title') info.append(make('p', '', item.variant_title));
            if (item.selling_plan_allocation?.selling_plan?.name) info.append(make('p', '', item.selling_plan_allocation.selling_plan.name));
            const meta = make('div', 'vt-drawer-item-meta');
            const stepper = make('div', 'vt-drawer-stepper'); stepper.setAttribute('role', 'group'); stepper.setAttribute('aria-label', this.dataset.quantity + ': ' + item.product_title);
            [-1, 1].forEach(direction => {
              const button = make('button', '', direction < 0 ? '−' : '+'); button.type = 'button';
              button.dataset.key = item.key; button.dataset.direction = String(direction);
              button.setAttribute('aria-label', (direction < 0 ? this.dataset.decrease : this.dataset.increase) + ': ' + item.product_title);
              button.disabled = !!this.changing;
              button.addEventListener('click', () => this.changeQuantity(item, direction));
              stepper.append(button);
              if (direction < 0) stepper.append(make('span', '', String(item.quantity)));
            });
            meta.append(stepper, make('strong', '', money(item.final_line_price))); info.append(meta);
            row.append(imageLink, info); items.append(row);
          });
          this.querySelector('[data-drawer-count]').textContent = String(cart.item_count);
          document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = String(cart.item_count); });
          status.textContent = cart.item_count ? '' : this.dataset.empty;
          this.querySelector('[data-drawer-total]').textContent = money(cart.total_price);
          total.hidden = !cart.item_count; tax.hidden = !cart.item_count; review.hidden = !cart.item_count; shop.hidden = !!cart.item_count;
        } catch (error) { if (!signal.aborted) { items.replaceChildren(); status.textContent = this.dataset.error; } }
        finally { if (!signal.aborted) items.removeAttribute('aria-busy'); }
      }
      disconnectedCallback() { this.abort?.abort(); this.request?.abort(); this.dialog?.close(); document.documentElement.classList.remove('vt-drawer-open'); }
    });
  }
  if (!customElements.get('voltara-quantity')) {
    customElements.define('voltara-quantity', class extends HTMLElement {
      connectedCallback() {
        if (this.button) return;
        this.select = this.querySelector('select');
        if (!this.select) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.button = document.createElement('button');
        this.button.type = 'button'; this.button.className = 'vt-quantity-trigger';
        this.button.id = this.select.id; this.select.id += '-native';
        this.button.setAttribute('aria-label', this.select.getAttribute('aria-label'));
        this.button.setAttribute('aria-expanded', 'false');
        this.button.textContent = this.select.value;
        this.menu = document.createElement('div'); this.menu.className = 'vt-quantity-menu'; this.menu.hidden = true;
        this.menu.id = this.button.id + '-choices'; this.button.setAttribute('aria-controls', this.menu.id);
        this.options = [...this.select.options].map(option => {
          const button = document.createElement('button'); button.type = 'button'; button.textContent = option.textContent;
          button.setAttribute('aria-pressed', String(option.selected));
          button.addEventListener('click', () => this.choose(option.value), { signal });
          this.menu.append(button); return button;
        });
        this.append(this.button, this.menu); this.select.hidden = true;
        this.button.addEventListener('click', () => this.menu.hidden ? this.open() : this.close(), { signal });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') { this.close(); this.button.focus(); return; }
          if (!['ArrowDown','ArrowUp','Home','End'].includes(event.key)) return;
          event.preventDefault();
          if (this.menu.hidden) { this.open(); return; }
          const current = this.options.indexOf(document.activeElement);
          const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.options.length - 1 : (current + (event.key === 'ArrowDown' ? 1 : -1) + this.options.length) % this.options.length;
          this.options[index].focus();
        }, { signal });
        document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) this.close(); }, { signal });
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.close(); }, { signal });
        window.addEventListener('resize', () => this.close(), { signal });
        window.addEventListener('scroll', event => { if (!this.menu.contains(event.target)) this.close(); }, { signal, capture: true, passive: true });
        window.addEventListener('pageshow', () => { this.button.disabled = false; this.button.textContent = this.select.value; const form = this.closest('form'); form?.removeAttribute('aria-busy'); const status = form?.querySelector('.vt-cart-updating'); if (status) status.hidden = true; }, { signal });
      }
      open() {
        const rect = this.button.getBoundingClientRect();
        const height = Math.min(196, this.options.length * 36 + 12);
        this.menu.style.left = Math.max(12, Math.min(rect.left, window.innerWidth - 124)) + 'px';
        this.menu.style.top = Math.max(12, window.innerHeight - rect.bottom >= height + 12 ? rect.bottom + 6 : rect.top - height - 6) + 'px';
        this.menu.hidden = false; this.button.setAttribute('aria-expanded', 'true');
        this.options[this.select.selectedIndex]?.focus({ preventScroll: true });
        const active = this.options[this.select.selectedIndex]; if (active) this.menu.scrollTop = active.offsetTop - 72;
      }
      close() { this.menu.hidden = true; this.button.setAttribute('aria-expanded', 'false'); }
      choose(value) {
        this.close(); this.button.focus();
        if (value === this.select.value) return;
        this.select.value = value; this.button.textContent = value;
        this.options.forEach(option => option.setAttribute('aria-pressed', String(option.textContent === value)));
        const form = this.closest('form'); const update = form?.querySelector('button[name="update"]');
        if (form && update) {
          if (!form.reportValidity()) return;
          this.button.disabled = true; form.setAttribute('aria-busy', 'true');
          const status = form.querySelector('.vt-cart-updating'); if (status) status.hidden = false;
          form.requestSubmit(update);
        }
      }
      disconnectedCallback() { this.abort?.abort(); this.button?.remove(); this.menu?.remove(); if (this.select) { this.select.id = this.select.id.replace(/-native$/, ''); this.select.hidden = false; } this.button = null; }
    });
  }
  if (!customElements.get('voltara-product')) {
    class VoltaraProduct extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.form = this.querySelector('.vt-purchase-form');
        this.select = this.querySelector('[data-variant-select]');
        this.quantity = this.form?.querySelector('[name="quantity"]');
        this.message = this.querySelector('[data-form-message]');
        this.dialog = this.querySelector('dialog');
        this.pending = false;
        this.gallery = this.querySelector('.vt-gallery-stage');
        this.touchStart = null;
        this.gallery?.addEventListener('keydown', event => {
          if (event.target !== this.gallery || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.moveMedia(event.key === 'ArrowRight' ? 1 : -1);
        }, { signal: this.abort.signal });
        this.gallery?.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'touch' || event.target.closest('video,iframe,model-viewer')) return;
          this.touchStart = { x: event.clientX, y: event.clientY };
        }, { signal: this.abort.signal, passive: true });
        this.gallery?.addEventListener('pointerup', event => {
          if (!this.touchStart) return;
          const dx = event.clientX - this.touchStart.x;
          const dy = event.clientY - this.touchStart.y;
          this.touchStart = null;
          if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.4) this.moveMedia(dx < 0 ? 1 : -1);
        }, { signal: this.abort.signal, passive: true });
        this.gallery?.addEventListener('pointercancel', () => { this.touchStart = null; }, { signal: this.abort.signal });
        this.addEventListener('click', event => {
          const target = event.target.closest('button');
          if (!target) return;
          if (target.dataset.mediaTarget) this.showMedia(target.dataset.mediaTarget);
          if (target.dataset.galleryDirection) this.moveMedia(Number(target.dataset.galleryDirection));
          if (target.dataset.quantity && this.quantity) {
            target.dataset.quantity === 'plus' ? this.quantity.stepUp() : this.quantity.stepDown();
            this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
          }
          if (target.hasAttribute('data-close-dialog')) this.dialog?.close();
        }, { signal: this.abort.signal });
        this.select?.addEventListener('change', () => this.updateVariant(), { signal: this.abort.signal });
        this.quantity?.addEventListener('change', () => {
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.quantity.animate?.([{ transform: 'translateY(-4px)', opacity: .45 }, { transform: 'translateY(0)', opacity: 1 }], { duration: 220, easing: 'ease-out' });
        }, { signal: this.abort.signal });
        this.form?.addEventListener('submit', event => this.addToCart(event), { signal: this.abort.signal });
        this.dialog?.addEventListener('click', event => { if (event.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close(); } }, { signal: this.abort.signal });
      }
      moveMedia(direction) {
        const slides = [...this.querySelectorAll('[data-media-id]')];
        if (slides.length < 2) return;
        const current = Math.max(0, slides.findIndex(el => !el.hidden));
        this.showMedia(slides[(current + direction + slides.length) % slides.length].dataset.mediaId);
      }
      showMedia(id) {
        const slides = [...this.querySelectorAll('[data-media-id]')];
        const selected = slides.find(el => el.dataset.mediaId === String(id));
        if (!selected) return;
        slides.forEach(el => { el.hidden = el !== selected; if (el.hidden) el.querySelectorAll('video').forEach(video => video.pause()); });
        this.querySelectorAll('[data-media-target]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.mediaTarget === String(id))));
        const index = this.querySelector('[data-gallery-index]');
        if (index) index.textContent = String(slides.indexOf(selected) + 1);
        const thumb = this.querySelector(`[data-media-target="${id}"]`);
        if (thumb?.parentElement) {
          const rail = thumb.parentElement;
          rail.scrollTo({ left: thumb.offsetLeft - rail.offsetLeft - rail.clientWidth / 2 + thumb.offsetWidth / 2, behavior: 'instant' });
        }
      }
      updateVariant() {
        const option = this.select?.selectedOptions[0];
        if (!option) return;
        const data = option.dataset;
        this.querySelectorAll('[data-variant-price],[data-button-price],[data-sticky-price]').forEach(el => { el.textContent = data.price; });
        [['[data-compare-price]', data.compare], ['[data-saving]', data.saving]].forEach(([selector, value]) => { const el = this.querySelector(selector); if (el) { el.hidden = !value; el.textContent = value || ''; } });
        if (this.quantity) { this.quantity.min = data.min || '1'; this.quantity.step = data.step || '1'; if (data.max) this.quantity.max = data.max; else this.quantity.removeAttribute('max'); this.quantity.value = data.min || '1'; }
        this.syncButtons();
        if (data.media) this.showMedia(data.media);
        const url = new URL(window.location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
        if (this.message) this.message.textContent = '';
      }
      syncButtons() {
        const available = this.select?.selectedOptions[0]?.dataset.available === 'true';
        this.querySelectorAll('[data-add-button]').forEach(button => { button.disabled = this.pending || !available; button.setAttribute('aria-busy', String(this.pending)); });
        this.querySelectorAll('[data-add-label]').forEach(el => { el.textContent = this.pending ? this.dataset.adding : available ? this.dataset.add : this.dataset.soldOut; });
      }
      async flyToBag(origin, quantity) {
        const bag = document.querySelector('.vt-bag-link');
        const photo = this.querySelector('[data-media-id]:not([hidden]) img');
        if (!bag || !photo || !photo.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        let start = photo.getBoundingClientRect();
        if (start.bottom < 80 || start.top > window.innerHeight - 80) start = (origin || this.form).getBoundingClientRect();
        const end = bag.getBoundingClientRect();
        const size = 72, x = start.left + start.width / 2 - size / 2, y = Math.max(85, Math.min(window.innerHeight - 90, start.top + start.height / 2 - size / 2));
        const dx = end.left + end.width / 2 - x - size / 2, dy = end.top + end.height / 2 - y - size / 2;
        const token = document.createElement('div');
        token.className = 'vt-flying-product'; token.setAttribute('aria-hidden', 'true');
        token.style.left = x + 'px'; token.style.top = y + 'px';
        const img = document.createElement('img'); img.src = photo.currentSrc || photo.src; img.alt = ''; token.append(img);
        const badge = document.createElement('span'); badge.textContent = '×' + quantity; token.append(badge);
        document.body.append(token); this.flightToken = token;
        try {
          await token.animate([{ transform: 'translate(0,0) scale(1)', opacity: 1 }, { transform: `translate(${dx * .48}px,${dy * .55 - 65}px) scale(.85)`, opacity: 1, offset: .5 }, { transform: `translate(${dx}px,${dy}px) scale(.14)`, opacity: .1 }], { duration: 650, easing: 'cubic-bezier(.4,0,.2,1)' }).finished;
          bag.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.22)', color: '#93dcff' }, { transform: 'scale(1)' }], { duration: 260 });
        } finally { token.remove(); this.flightToken = null; }
      }
      async addToCart(event) {
        if (!window.fetch || !this.form || !this.select) return;
        event.preventDefault();
        if (this.pending || !this.form.reportValidity()) return;
        this.pending = true; this.syncButtons(); this.message.textContent = '';
        const selectedQuantity = this.quantity?.value || '1';
        const selectedPrice = this.select.selectedOptions[0]?.dataset.price || '';
        const root = window.Shopify?.routes?.root || '/';
        try {
          const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(this.form) });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          const previewQuantity = this.querySelector('[data-bag-preview-quantity]');
          const previewPrice = this.querySelector('[data-bag-preview-price]');
          const previewVariant = this.querySelector('[data-bag-preview-variant]');
          const previewImage = this.querySelector('[data-bag-preview-image]');
          if (previewQuantity) previewQuantity.textContent = selectedQuantity;
          if (previewPrice) previewPrice.textContent = selectedPrice + ' × ' + selectedQuantity;
          if (previewVariant) { previewVariant.textContent = result.variant_title || ''; previewVariant.hidden = !result.variant_title || result.variant_title === 'Default Title'; }
          if (previewImage && (result.featured_image?.url || result.image)) { previewImage.removeAttribute('srcset'); previewImage.src = result.featured_image?.url || result.image; }
          try { await this.flyToBag(event.submitter, selectedQuantity); } catch {}
          try { const cartResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); if (cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = String(cart.item_count)); } } catch {}
          const drawer = document.querySelector('voltara-cart-drawer');
          if (drawer?.dialog?.showModal) await drawer.open();
          else if (this.dialog?.showModal) this.dialog.showModal(); else window.location.assign(this.dataset.cartUrl);
        } catch (error) { this.message.textContent = error.message || this.dataset.error; }
        finally { this.pending = false; this.syncButtons(); }
      }
      disconnectedCallback() { this.abort?.abort(); this.flightToken?.remove(); }
    }
    customElements.define('voltara-product', VoltaraProduct);
  }
  const media = window.matchMedia('(prefers-reduced-motion: reduce)');
  let motionContext, lenis, ticker;
  const stopMotion = () => { motionContext?.revert(); motionContext = null; lenis?.destroy(); lenis = null; if (ticker && window.gsap) gsap.ticker.remove(ticker); ticker = null; };
  const startMotion = () => {
    stopMotion();
    const hero = document.querySelector('.vt-hero');
    if (!hero || media.matches || window.Shopify?.designMode || !window.gsap || !window.ScrollTrigger) return;
    gsap.registerPlugin(ScrollTrigger);
    motionContext = gsap.context(() => {
      gsap.from('.vt-hero-copy > *', { y: 24, opacity: 0, duration: .85, stagger: .12, ease: 'power2.out' });
      gsap.from('.vt-orbit-art', { opacity: 0, scale: .88, duration: 1.4, ease: 'power2.out' });
      gsap.to('.vt-orbit-art', { y: -55, rotation: 5, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: .8 } });
      gsap.utils.toArray('.vt-categories,.vt-new-in,.vt-brand-story').forEach(el => gsap.from(el, { y: 25, opacity: 0, duration: .85, scrollTrigger: { trigger: el, start: 'top 95%', once: true } }));
    }, document.body);
    if (window.Lenis && matchMedia('(pointer:fine)').matches) { lenis = new Lenis({ duration: 1, anchors: true }); lenis.on('scroll', ScrollTrigger.update); ticker = t => lenis?.raf(t * 1000); gsap.ticker.add(ticker); }
    ScrollTrigger.refresh();
  };
  media.addEventListener('change', startMotion);
  document.addEventListener('shopify:section:load', startMotion);
  window.addEventListener('pagehide', stopMotion);
  window.addEventListener('pageshow', event => { if (event.persisted) startMotion(); });
  startMotion();
})();
